import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';

import './styles.css';

export class DesktopHeaders extends React.Component {

  private i18n = getI18n();

  public render() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} />
          {/* <Table.HeaderCell width={6} className="product-name-header">
          {this.i18n.t(translations.ProductName)}</Table.HeaderCell> */}
          <Table.HeaderCell width={6} className="product-details-header">{this.i18n.t(translations.ProductDetails)}</Table.HeaderCell>
          <Table.HeaderCell width={8} className="product-status-header">{this.i18n.t(translations.Status)}</Table.HeaderCell>
          <Table.HeaderCell width={1} />
        </Table.Row>
      </Table.Header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/headers/desktop-headers.tsx